import { isSelectableChartType, resolveDataType } from '@revelio/core';

import {
  isTableDataSetType,
  type TableDataSetType,
} from '../../DataProvider/utils/table-to-data-set';
import {
  isShareOfSegmentPlot,
  type PositionedItem,
} from '../../PageConfigProvider/types/item';
import type { MetricValues } from '../../PageConfigProvider/types/metric';

export const getResolvedDataSetType = (
  item: PositionedItem,
  metric: MetricValues | undefined
): TableDataSetType | undefined => {
  const { chartType, secondaryDimension, dimensionSource } = item.plot ?? {};

  if (!metric || !isSelectableChartType(chartType) || chartType === 'table') {
    return undefined;
  }

  const resolution = resolveDataType(
    chartType,
    metric,
    secondaryDimension,
    dimensionSource
  );
  return resolution.compatible &&
    isTableDataSetType(resolution.resolvedDataType)
    ? resolution.resolvedDataType
    : undefined;
};

export const canDrawResolvedData = (
  item: PositionedItem,
  metric: MetricValues | undefined
): boolean => {
  if (item.plot?.chartType === 'table') return Boolean(metric);
  return (
    isShareOfSegmentPlot(item.plot) ||
    item.plot?.chartType === 'icicle' ||
    item.plot?.chartType === 'gauge-v2' ||
    item.plot?.chartType === 'text' ||
    getResolvedDataSetType(item, metric) !== undefined
  );
};
